
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Senior Consultant  - IT
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p>B.E / B.Tech. / Any bachelor Computer Degree- PG preferable</p>
              <!-- <p>Essential qualification B.E Computer Science Engineering (or) MBA (or) M.Sc. Electronics media (or) M.Sc. Visual Communication (or) any equivalent master degree from recognized university / institutes.</p>
                <p> Conversion skills coupled with the communication skill in English & Hindi language is preferable</p> -->
            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Age limit: </h3>
              <p> Candidates should be below 40 years of age as on the date of advertisement
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <!-- <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Vacancy: </h3>
              <p> 1- Post
</p>

            </div>
          </div>
        </div> -->
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Rs.60,000- 70,000/- per month  </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 31th Mar 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Eligibility Criteria</h3>
		<p>5+ year experience as Senior Manager/ Senior Project Manager desirable</p>
        <!-- <p> <span class="step_no">1</span>Minimum 3 to 5  year's experience in full life cycle project management related to e-learning content</p>
        <p> <span class="step_no">2</span>Should have 3 year's manager level experience in e-learning or animation firms or media houses </p>
        <p> <span class="step_no">3</span>Minimum 1 project with any Central Government / State Government / Universities or Institutes of Higher education (Established by a Status) / Education Technology Companies on e-learning projects</p>
			 -->



      </div>
    </div>
  </div>
  <!-- feature box close -->

<!-- feature box begin -->
<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>JOB requirement</h3>        
<p><span class="step_no">1</span>Degree/PG in Computer science, information systems or related</p>
<p><span class="step_no">2</span>Previous experience in an IT management position.</p>
<p><span class="step_no">3</span>A strong understanding of IT infrastructure and security</p>
<p><span class="step_no">4</span>Excellent organizational and leadership skills</p>
<p><span class="step_no">5</span>Strong communication skills</p>
<p><span class="step_no">6</span>Excellent analytical skills</p>
<!-- <p><span class="step_no">7</span>Any other work as per MSDE requirement.</p> -->


      </div>
    </div>
  </div>
  <!-- feature box close -->


  <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key responsibility:</h3>
		
        <p> <span class="step_no">1</span>Managing content development</p>
        <p> <span class="step_no">2</span>Resolving client queries and problems.</p>
         <p> <span class="step_no">3</span>Managing and guiding junior consultants</p>
		<p> <span class="step_no">4</span>Supporting business development activities</p>
        <p> <span class="step_no">5</span>Performing financial analyses</p>
        <p> <span class="step_no">6</span>Assessing computing needs, shortcomings,and requirements.</p>
        <p> <span class="step_no">7</span>Overseeing daily operations within the department</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Design, implement and Support financial management systems and procedures
</p>
<p><span class="step_no">2</span>Ensure fulfil1ment of requirements as laid under the financial management manual of SANKALP</p>
<p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

          <!-- feature box begin -->
 <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Period of Contract:</h3>
            <p>11 month(Renewable) </p>   
   
          </div>
        </div>
      </div> 
      <!-- feature box close -->

 <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Method of recruitment:</h3>
            <p>Contract based through open market</p>        

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Location</h3>
       		<p>01-Post Chennai </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

 <!-- feature box begin -->
 <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Notification</h3>
       		<p><a href="assets/pdf/SANKALP_SENIOR_CONSULTANT_1.pdf" target="_blank">Click here to download</a></p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->


  

<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>


